/* ==========================================================================
   WeTuning Santiago — Tracking de clics a WhatsApp
   El href de cada botón ya viene construido desde Liquid (snippets/
   wetuning-whatsapp-button.liquid), así que este script NO reconstruye
   enlaces: solo instrumenta el clic para analytics (punto 57/58 del brief)
   y evita comportamientos de doble apertura. Si este script no carga, los
   botones siguen funcionando igual porque son <a href> reales.
   ========================================================================== */
(function () {
  "use strict";

  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest("[data-wt-whatsapp]");
      if (!trigger) return;

      var detail = {
        service: trigger.getAttribute("data-wt-service") || "general",
        context: trigger.getAttribute("data-wt-context") || "inline",
      };

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "wt_whatsapp_click",
          wt_service: detail.service,
          wt_context: detail.context,
        });
      } catch (err) {
        /* no bloquear el clic si dataLayer no existe todavía */
      }

      try {
        document.dispatchEvent(new CustomEvent("wt:whatsapp_click", { detail: detail }));
      } catch (err) {
        /* CustomEvent no soportado en navegadores muy antiguos: se ignora */
      }

      /* No se usa target="_blank" en los enlaces (ver snippet), por lo que
         un clic nunca abre una ventana nueva y no hay riesgo de duplicados. */
    },
    { passive: true }
  );
})();
